import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=1d883b5a&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=js&"
export * from "./Work.vue?vue&type=script&lang=js&"
import style0 from "./Work.vue?vue&type=style&index=0&id=1d883b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d883b5a",
  null
  
)

export default component.exports